import React from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { Slot } from 'radix-ui'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'

import { useWithAffectedOGsHandler } from '@/entities/optimization-group'
import { useDublicatePricingCampaignsMutation } from '@/entities/pricing-campaign'

export const DuplicatePricingCampaign = ({
	pricingCampaignId,
	destinationIds = [],
	destinationType = 'optimization_group' as const,
	children,
}: {
	pricingCampaignId: string
	destinationIds: (string | null)[]
	destinationType: 'scenario' | 'optimization_group' | 'global_pc_set'
	children: React.ReactNode
}) => {
	const { t } = useTranslation()

	const queryClient = useQueryClient()
	const dublicatePricingCampaignsMutation =
		useDublicatePricingCampaignsMutation({
			mutationKey: ['pricing-campaign-duplicate'],
			onSuccess() {
				queryClient.invalidateQueries({
					queryKey: ['products-counts-by-pc'],
				})

				queryClient.invalidateQueries({
					queryKey: ['pricing-campaigns'],
				})

				return queryClient.invalidateQueries({
					queryKey: ['pricing-campaigns-overview'],
				})
			},
		})
	const dublicate = useWithAffectedOGsHandler(dublicatePricingCampaignsMutation)
	const handleDublicate = async () => {
		toast.promise(
			dublicate.mutateAsync({
				src_pricing_campaign_ids: [pricingCampaignId],
				dst_entity_ids: destinationIds,
				dst_entity_type: destinationType,
			}),
			{
				loading: t('duplicating.proccess', { defaultValue: 'Duplicating...' }),
				success: t('duplicating.success', {
					defaultValue: 'Duplicated successfully',
				}),
				error: t('duplicating.error', {
					defaultValue: 'Error while duplicating',
				}),
			}
		)
	}

	return <Slot.Root onClick={handleDublicate}>{children}</Slot.Root>
}
